export default __webpack_public_path__ + "static/media/register.90b086c7.png";